import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks"
import { PrimaryButton } from "./buttons/PrimaryButton";
import LanguageSelector from "./main_page/LanguageSelector"
import { MainMenuButton } from "./navbar/MainMenuButton"
import { SearchBar } from "./navbar/SearchBar"
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import logo from '../assets/images/Rentic_logo.svg';
import { NotificationsButton } from "./navbar/NotificationsButton";

export const Navbar: React.FC = () => {
    const user = useAppSelector(state => state.auth.user);
    const apiInitialized = useAppSelector(state => state.auth.apiAuthInitilized);
    const displayType = useAppSelector(state => state.display.type);
    const navigate = useNavigate();

    const [scrolled, setScrolled] = useState(false);
    const [scrollAmount, setScrollAmount] = useState<number>(0);
    const location = useLocation(); // Get the current route

    useEffect(() => {
        const handleScroll = () => {
            setScrollAmount(window.scrollY);
            // Only apply logic on the specific page
            const viewportHeight = window.innerHeight * 0.4; // 40vh in pixels
            if (window.scrollY > viewportHeight) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    return (
        <div>
            <div className="h-[60px]"></div>
            <div className={`w-full flex justify-center z-40 h-16 top-0 px-4 fixed shadow-main transition-all duration-200 bg-white 
                ${scrollAmount == 0 && "shadow-none"}`}>
                <div className="flex flex-row w-full justify-between items-center max-w-[1500px] h-full" id={"application_top_bar"}>
                    <div className="flex items-center text-xl cursor-pointer h-5/6"><div onClick={() => navigate("/")} className="h-full">
                        <img src={logo} alt="" className="h-full" />
                    </div>
                    </div>
                    <div className={`w-[360px] ${scrolled || location.pathname == "/search" ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-all duration-300`}>
                        <SearchBar />
                    </div>

                    <div className="flex flex-row gap-4 items-center space-x-2 h-full" id={'navbar_menu_right_elements'}>


                        <MainMenuButton></MainMenuButton>
                        {!user &&
                            <div className="min-w-[160px]">

                                <PrimaryButton onClick={() => navigate("/login")} title="Logi sisse"></PrimaryButton>

                            </div>
                        }
                        <div className="min-w-[130px]">
                            <PrimaryButton outlined={true} title={"Loo kuulutus"} onClick={() => { navigate("/edit") }} />
                        </div>

                        {user?.id && apiInitialized &&
                            <NotificationsButton />}

                        {/* <LanguageSelector /> */}
                    </div>
                </div>
            </div>
        </div>

    )
}